import PropTypes from 'prop-types';
import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { useDispatch } from '../../redux/store';
import { updateSingleTicket } from '../../redux/slices/tickets';
import { postPinTicket } from '../../api/tickets';

PinToggle.propTypes = {
  value: PropTypes.bool,
  ticketId: PropTypes.number,
};

export default function PinToggle({ value, ticketId }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handlePin = async () => {
    setLoading(true);
    try {
      const { data } = await postPinTicket({ ticketId });
      if (data) {
        enqueueSnackbar(`Ticket ${ticketId} ${value ? 'unpinned' : 'pinned'} successfully`, { variant: 'success' });
        dispatch(updateSingleTicket(data));
      } else enqueueSnackbar(`Error: Could not ${value ? 'unpin' : 'pin'} ticket ${ticketId}`, { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(`Error: Could not ${value ? 'unpin' : 'pin'} ticket ${ticketId}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip arrow title={value ? 'Unpin ticket' : 'Pin ticket'}>
      <IconButton
        color="secondary"
        onClick={async (e) => { e.stopPropagation(); if (!loading) await handlePin(); }}
        sx={loading ? { opacity: .5 } : { opacity: 0.7, '&:hover': { opacity: 1 } }}
      >
        {value ? <PushPinIcon /> : <PushPinOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
